import { render, staticRenderFns } from "./BaseTaskStateSelect.vue?vue&type=template&id=00b72b32&scoped=true&lang=pug&"
import script from "./BaseTaskStateSelect.vue?vue&type=script&lang=js&"
export * from "./BaseTaskStateSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseTaskStateSelect.vue?vue&type=style&index=0&id=00b72b32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b72b32",
  null
  
)

export default component.exports